var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_20086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.033 4.11084C9.19239 4.11084 6.23927 4.72022 3.78771 6.20147C-1.39198 9.32803 -0.782608 16.1624 2.75177 20.3249C4.10646 21.9187 7.42052 24.9327 9.78302 23.6483C11.433 22.753 10.7393 21.464 10.4533 20.503C10.2846 19.9265 10.7158 19.3499 11.3158 19.3546C11.3205 19.3546 11.3252 19.3546 11.3299 19.3546C17.9393 19.3546 23.9955 15.9046 23.9955 11.7093C23.9955 7.51397 18.6424 4.11084 12.033 4.11084Z",
    fill: "#D28E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32969 19.3968C6.43512 19.3968 7.33125 18.5007 7.33125 17.3952C7.33125 16.2898 6.43512 15.3937 5.32969 15.3937C4.22425 15.3937 3.32812 16.2898 3.32812 17.3952C3.32812 18.5007 4.22425 19.3968 5.32969 19.3968Z",
    fill: "#FFCC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24229 13.5C5.34772 13.5 6.24385 12.6038 6.24385 11.4984C6.24385 10.393 5.34772 9.49683 4.24229 9.49683C3.13685 9.49683 2.24072 10.393 2.24072 11.4984C2.24072 12.6038 3.13685 13.5 4.24229 13.5Z",
    fill: "#43C6B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86289 10.4719C10.9683 10.4719 11.8645 9.57574 11.8645 8.47031C11.8645 7.36488 10.9683 6.46875 9.86289 6.46875C8.75746 6.46875 7.86133 7.36488 7.86133 8.47031C7.86133 9.57574 8.75746 10.4719 9.86289 10.4719Z",
    fill: "#E16464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1158 9.99837C17.2213 9.99837 18.1174 9.10224 18.1174 7.9968C18.1174 6.89137 17.2213 5.99524 16.1158 5.99524C15.0104 5.99524 14.1143 6.89137 14.1143 7.9968C14.1143 9.10224 15.0104 9.99837 16.1158 9.99837Z",
    fill: "#50C4DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1469 7.1625L18.4922 6.46875L16.8422 7.16719C16.8422 7.16719 16.6922 9.64687 17.6391 12.1594L18.4922 13.2422L19.3453 12.1594C20.2969 9.64219 20.1469 7.1625 20.1469 7.1625Z",
    fill: "#E7EEF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3503 12.1547C20.6721 15.5062 20.1799 23.5875 18.4971 23.5875C16.8143 23.5875 16.3221 15.5062 17.644 12.1547H19.3503Z",
    fill: "#50C4DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.283 2.51244C19.5798 1.79526 19.2048 1.08744 18.9986 0.539005C18.8111 0.0327552 18.2439 -0.121932 17.8642 0.234318C17.0392 1.00776 15.9189 2.45619 15.8064 4.71088C15.7549 5.68588 16.097 6.38432 16.547 6.88119C17.5361 7.97807 19.1252 8.05776 20.2173 7.06869C20.7142 6.61869 21.1267 5.95776 21.1783 4.98276C21.1783 4.97807 21.1783 4.96869 21.1783 4.96401C21.2252 4.03588 20.8923 3.13588 20.283 2.51244Z",
    fill: "#3A484A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_20086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt);
export default __webpack_public_path__ + "static/media/art.aa81d6287c062c2c7bdfdb5823daed85.svg";
export { ForwardRef as ReactComponent };